import Modal from 'react-modal';
import { useEffect, useRef, useState } from 'react';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';

import api from '../../services/api';
import Button from '../Button';
import Input from '../Input';
import Notification from '../Notification';
import UserSelect from '../UserSelect';

import { Headline, ButtonsContainer, modalStyles } from './styles';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  initialData: PropTypes.object.isRequired,
};

const EditVoucherModal = ({ isOpen, onClose, onConfirm, initialData }) => {
  const formRef = useRef(null);

  const [isLoading, setLoading] = useState(false);
  const [owner, setOwner] = useState(initialData?.ownerOption ?? null);

  // O modal fica montado entre um voucher e outro, então o estado do select
  // não se refaz sozinho: sem isto, abrir o segundo voucher mostraria o dono
  // do primeiro.
  useEffect(() => {
    setOwner(initialData?.ownerOption ?? null);
  }, [initialData]);

  async function handleSubmitForm(data) {
    try {
      setLoading(true);
      // Sempre explícito: `null` diz ao back para desvincular o dono, coisa
      // que o formulário antigo, por documento, não conseguia expressar.
      await api.put(`/admin/voucher/${initialData.id}`, {
        ...data,
        ownerId: owner ? owner.value : null,
      });
      Notification({
        message: 'Voucher editado com sucesso',
        type: Notification.types.SUCCESS,
      });
      onConfirm();
    } catch (err) {
      if (err.response) {
        Notification({
          message: err.response.data.error,
          type: Notification.types.ERROR,
        });
        if (err.response.data.errors) {
          formRef.current.setErrors(err.response.data.errors);
        }
      } else {
        Notification({
          message: 'Erro ao editar voucher',
          type: Notification.types.ERROR,
        });
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Editar voucher"
      style={modalStyles}
      closeTimeoutMS={500}
    >
      {isLoading && <div className="loader" />}
      <Headline>Editar voucher</Headline>
      <Form onSubmit={handleSubmitForm} ref={formRef} initialData={initialData}>
        <Input type="number" label="Valor do voucher" name="value" />
        <Input
          type="number"
          label="Dias para expirar voucher"
          name="expiresAtDays"
          placeholder="Deixe em branco para manter inalterado"
        />
        <Input type="number" label="Nº máximo de usos" name="maxUses" />
        <UserSelect
          label="Proprietário (opcional)"
          value={owner}
          onChange={setOwner}
        />
        <ButtonsContainer>
          <Button text="Cancelar" onClick={onClose} />
          <Button text="Confirmar" primary type="submit" />
        </ButtonsContainer>
      </Form>
    </Modal>
  );
};

EditVoucherModal.propTypes = propTypes;

export default EditVoucherModal;
